export const VERTICES = {
  SQUARE: 1,
  TRIANGLE: 2,
  CIRCLE: 3,
  HEXAGON: 4,
  OCTAGON: 5
};

export const ANCHORS = {
  SINGLE: 1,
  LINEAR: 'custom_linear',
  TRIANGULAR: 3,
  EDGE_MATRIX: 4,
  MATRIX: 5,
  ROUNDED_EDGE_MATRIX: 6,
  CIRCULAR: 7
};



// WEBPACK FOOTER //
// ./src/components/Editor/types.js